<template>
  <teleport to="body">
    <!-- Fullscreen wrapper, only visible when open -->
    <div v-if="modalValue.show" class="fixed inset-0 z-[1000] flex items-center justify-center">
      <!-- Backdrop with its own transition -->
      <Transition
        name="backdrop"
        enter-active-class="transition-opacity duration-150"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-150"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
        :appear="true"
      >
        <div
          v-if="backdrop && modalValue.show"
          class="absolute inset-0 bg-black/50 backdrop-blur-sm"
          @click="onClose"
        />
      </Transition>

      <!-- Dialog with slide-from-right animation -->
      <Transition
        name="custom-classes"
        enter-active-class="animate__animated animate__fadeInRight animate__faster"
        leave-active-class="animate__animated animate__fadeOutRight animate__faster"
        :appear="true"
        mode="out-in"
      >
        <!-- Panel centered on the screen -->
        <div
          v-if="modalValue.show"
          class="relative w-full max-w-xl p-4 z-[1001]"
        >
          <div class="relative w-full rounded-xl bg-white shadow-xl max-h-[85vh] overflow-y-auto">
            <!-- Your content unchanged -->
            <slot name="content">
              <div class="text-center items-center justify-center px-12 py-5">
                <button
                  v-if="!noCancelIcon"
                  class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                  @click="onClose"
                >✕</button>

                <slot name="icon">
                  <div class="flex justify-center mb-2" v-if="!noIcon">
                    <div class="w-12 h-12 rounded-full bg-error/20 flex items-center justify-center">
                      <i class="bi text-[24px] font-bold" :class="`bi-${iconClass} text-${iconColor}`"></i>
                    </div>
                  </div>
                </slot>

                <slot name="header">
                  <h2 class="text-lg font-semibold text-center">{{ modalValue.title }}</h2>
                </slot>

                <slot name="content">
                  <p class="py-4 text-sm" v-html="fMessage"></p>
                </slot>

                <div class="modal-action flex gap-4">
                  <slot name="actions" :close="onClose" />
                  <button v-if="!noCancelButton" class="flex-1 btn btn-primary" @click="onClose">
                    Cancel
                  </button>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </Transition>
    </div>
  </teleport>
</template>

<script setup>

import {computed} from 'vue'

const modalValue = defineModel({
  type: Object, default: {
    show: false,
    title: 'Hello',
    message: 'This is a modal message.',
  }
})
const emit = defineEmits(['close'])
const props = defineProps({
  noCancelButton: {type: Boolean, default: false},
  noCancelIcon: {type: Boolean, default: false},
  noIcon: {type: Boolean, default: false},
  iconClass: {type: String, default: 'x-circle-fill'},
  iconColor: {type: String, default: 'error'},
  backdrop: {type: Boolean, default: true},
})

const fMessage = computed(() =>
    modalValue.value.message.replace(/\n/g, '<br>')
)

const onClose = () => {
  modalValue.value.show = false
  emit('close', modalValue.value)
}
</script>
<style scoped>
</style>